<template>
  <v-dialog v-model="visible" max-width="440px">
    <v-card style="overflow-y: hidden">
      <v-card-title class="py-2 px-4">{{ titulo }}</v-card-title>

      <v-divider class="my-0"></v-divider>

      <v-card-text class="pa-4">
        <v-form>
          <v-row>
            <v-col cols="12">
              <v-select
                v-model="form.conceptoUniversidadId"
                :items="conceptosUniversidades"
                item-value="id"
                item-text="concepto.nombre"
                label="Concepto Universidad"
                outlined
                dense
                hide-details
                clearable></v-select>

              <small v-for="error in errores.conceptoUniversidadId" :key="error" class="d-block text-danger">
                {{ error }}
              </small>
            </v-col>

            <v-col cols="12">
              <v-text-field
                v-model="form.monto"
                type="number"
                label="Monto"
                outlined
                dense
                hide-details
                clearable></v-text-field>

              <small v-for="error in errores.monto" :key="error" class="d-block text-danger">{{ error }}</small>
            </v-col>

            <v-col cols="12">
              <v-switch v-model="form.obligatorioATodos" label="Obligatorio a todos"></v-switch>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-divider class="my-0"></v-divider>

      <v-card-actions>
        <v-btn color="blue darken-1" text @click.prevent="cerrar"> Cerrar </v-btn>

        <v-btn
          color="blue darken-1"
          text
          :loading="enviando"
          :disabled="enviando"
          @click.prevent="validar(registrar, editar)">
          Guardar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import 'vue-select/dist/vue-select.css';
import CostoProgramaService from '../services/costo-programa.service';
import modalFormMixin from '../mixins/modal-form.mixin';
import apiConsumerMixin from '../mixins/api-consumer.mixin';
import conceptoUniversidadService from '../services/concepto-universidad.service';

export default {
  name: 'ModalFormularioCostosPrograma',
  mixins: [modalFormMixin, apiConsumerMixin],
  props: {
    programaUniversidadId: {
      type: Number,
      required: true,
    },
    universidadId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      conceptosUniversidades: [],
    };
  },
  watch: {
    'form.conceptoUniversidadId': function () {
      this.errores.conceptoUniversidadId = [];
    },
    'form.monto': function () {
      this.errores.monto = [];
    },
    'form.obligatorioATodos': function () {
      this.errores.obligatorioATodos = [];
    },
  },
  methods: {
    generarObjetoFormRegistrar() {
      return {
        id: null,
        programaUniversidadId: this.programaUniversidadId,
        conceptoUniversidadId: null,
        monto: null,
        obligatorioATodos: false,
      };
    },
    generarObjetoFormEditar(data) {
      return {
        id: data.id,
        programaUniversidadId: data.programaUniversidadId,
        conceptoUniversidadId: data.conceptoUniversidadId,
        monto: data.monto,
        obligatorioATodos: data.obligatorioATodos,
      };
    },
    async obtenerConceptosUniversidad() {
      this.conceptoUniversidad = null;

      await this.obtenerDatosMixin(conceptoUniversidadService.findAll, 'conceptosUniversidades', {
        universidadId: this.universidadId,
      });
    },
    abrir(accion, data = []) {
      this.abrirMixin(accion, data);
      this.obtenerConceptosUniversidad();
    },
    guardar(accion) {
      this.guardarDatosMixin(
        CostoProgramaService.create,
        CostoProgramaService.update,
        accion,
        this.form,
        this.nombreRecurso,
        () => {
          this.$emit('actualizarListado');
          this.cerrar();
        },
        (errores) => {
          this.errores = errores;
        },
      );
    },
    registrar() {
      this.guardar(this.accionesCrud.REGISTRAR);
    },
    editar() {
      this.guardar(this.accionesCrud.EDITAR);
    },
  },
};
</script>

<style scoped>
::v-deep .v-select.v-text-field--outlined:not(.v-text-field--single-line).v-input--dense .v-select__selections {
  padding: 0px 0;
}

::v-deep .v-text-field .v-input__control .v-input__slot {
  min-height: auto !important;
  display: flex !important;
  align-items: center !important;
}

::v-deep .v-text-field--outlined.v-input--dense .v-label {
  top: 5px;
}

::v-deep .v-text-field .v-label {
  font-weight: 400;
}
</style>
